import { render, staticRenderFns } from "./login.vue?vue&type=template&id=5f5ed80f&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=5f5ed80f&prod&scoped=true&lang=less&"
import style1 from "./login.vue?vue&type=style&index=1&id=5f5ed80f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ed80f",
  null
  
)

export default component.exports